import {
    get
} from "@/common/request"


export function GetNewsList() {
    return get("news_list/get")
}